import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import { getBarberItem } from '../../order/selectors';
import OrderInfoItemSingle from '../components/OrderInfoItemSingle';
import { removeItem, setItemQuantity } from '../../order/actions';

const OrderInfoItemSingleContainer = compose(
  connect(
    (state, ownProps) => ({
      item: getBarberItem(state, ownProps.barberId, ownProps.id),
    }),
    { removeItem, setItemQuantity },
  ),
  withHandlers({
    removeItem: props => () => props.removeItem(props.barberId, props.id),
    setItemQuantity: props => (newQuantity) => {
      props.setItemQuantity(props.barberId, props.item, newQuantity);
    },
  }),
)(OrderInfoItemSingle);

export default OrderInfoItemSingleContainer;
